/**
 * @module app.bdc.list.rollbackDateCreatedCtrl
 *
 */
define(['angular'], function(angular) {


    function RollbackDateCreatedCtrl($scope, $uibModalInstance) {
        var self = {};

        self.rollback = function() {
            $uibModalInstance.close(true);
        };

        self.doNotRollback = function() {
            $uibModalInstance.close(false);
        };

        return self;
    }

    RollbackDateCreatedCtrl.$inject = ['$scope', '$uibModalInstance', '$log'];

    angular.module('app.bdc.list.rollbackDateCreatedCtrl', ['ui.bootstrap.modal']).controller('RollbackDateCreatedCtrl', RollbackDateCreatedCtrl);
});
